import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M4 18h16V6H4v12zm8.75-10.75h4v4h-4v-4zm0 5.5h4v4h-4v-4zm-5.5-5.5h4v4h-4v-4zm0 5.5h4v4h-4v-4z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M7.25 7.25h4v4h-4zm5.5 0h4v4h-4zm-5.5 5.5h4v4h-4zm5.5 0h4v4h-4z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
}, "2")], 'ViewCozyTwoTone');